export default {
  pizzas: [
    {
      id: 0,
      imageUrl:
        'https://origami.lviv.ua/image/upjsejazum/havaj-e1590393484721-small.jpg',
      name: 'Піца Гавайська',
      types: [0, 1],
      sizes: [30, 40],
      price: 172,
      category: 3,
      rating: 4,
    },
    {
      id: 1,
      imageUrl: 'https://origami.lviv.ua/image/upjsejazum/kaprichoza-small.jpg',
      name: 'Піца Капрічоза',
      types: [0],
      sizes: [26, 40],
      price: 245,
      category: 3,
      rating: 6,
    },
    {
      id: 2,
      imageUrl: 'https://origami.lviv.ua/image/upjsejazum/domashnja-small.jpg',
      name: 'Піца Домашня',
      types: [0],
      sizes: [26, 40],
      price: 206,
      category: 0,
      rating: 4,
    },
    {
      id: 3,
      imageUrl: 'https://origami.lviv.ua/image/upjsejazum/ispanka-small.jpg',
      name: 'Піца Іспанка',
      types: [1],
      sizes: [26, 30, 40],
      price: 222,
      category: 0,
      rating: 2,
    },
    {
      id: 4,
      imageUrl: 'https://origami.lviv.ua/image/upjsejazum/korolivska-small.jpg',
      name: 'Піца Королівська',
      types: [0, 1],
      sizes: [26, 30, 40],
      price: 242,
      category: 0,
      rating: 8,
    },
    {
      id: 5,
      imageUrl: 'https://origami.lviv.ua/image/upjsejazum/marharyta-small.jpg',
      name: 'Піца Маргарита',
      types: [0],
      sizes: [30, 40],
      price: 177,
      category: 1,
      rating: 2,
    },
    {
      id: 6,
      imageUrl:
        'https://origami.lviv.ua/image/upjsejazum/vehetarianska-small.jpg',
      name: 'Піца Вегетаріанська',
      types: [0, 1],
      sizes: [26, 30, 40],
      price: 220,
      category: 1,
      rating: 9,
    },
    {
      id: 7,
      imageUrl: 'https://origami.lviv.ua/image/upjsejazum/saljami-small.jpg',
      name: 'Піца Салямі',
      types: [0, 1],
      sizes: [26, 30, 40],
      price: 261,
      category: 2,
      rating: 10,
    },
    {
      id: 8,
      imageUrl: 'https://origami.lviv.ua/image/upjsejazum/dytjacha-1-small.jpg',
      name: 'Піца Дитяча',
      types: [0, 1],
      sizes: [26, 30, 40],
      price: 206,
      category: 4,
      rating: 10,
    },
    {
      id: 9,
      imageUrl: 'https://origami.lviv.ua/image/upjsejazum/hrybna-small.jpg',
      name: 'Піца Грибна',
      types: [0, 1],
      sizes: [26, 30, 40],
      price: 213,
      category: 4,
      rating: 7,
    },
  ],
};
